export const WorkflowTabsData = {
    tabs: [
        {
            id: "engineering",
            name: "Engineering",
            title: "Prompting GitHub Copilot, GPT, and Replit Ghostwriter to scale coding speed and clarity.",
            content: [
                "Generate boilerplate and scaffolding code in seconds",
                "Review code for edge cases and security risks",
                "Convert legacy functions to modern syntax",
                "Auto-generate unit tests",
                "Explain code logic for handoffs"
            ]
        },
        {
            id: "design",
            name: "Design",
            title: "We use Midjourney, Galileo AI, and Figma plugins to fast-track ideation and UI flow planning.",
            content: [
                "Prompt Midjourney to explore early moodboards",
                "Use Galileo for UI wireframe generation",
                "Iterate color schemes with AI assistants",
                "Generate sample text/images for prototyping",
                "Copywriting with Jasper or ChatGPT for microcopy"
            ]
        },
        {
            id: "management",
            name: "Management",
            title: "AI is our co-pilot for clarity, speed, and decision-making in team and project ops.",
            content: [
                "Draft meeting summaries with Notion AI",
                "Automate status reports with ChatGPT plugins",
                "Use AI agents to monitor pull request velocity",
                "Structure project roadmaps with AI-assisted planners",
                "Turn Slack conversations into structured docs"
            ]
        }
    ]
}; 